import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './translations/en.json';
import translationDE from './translations/de.json';
import translationES from './translations/es.json';
import translationPT from './translations/pt.json';
import translationPTBR from './translations/pt-br.json';
import translationFR from './translations/fr.json';
import translationIT from './translations/it.json';
import translationHE from './translations/he.json';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
   resources: {
	  en: {
		translation: translationEN,
	  },
	  de: {
		translation: translationDE,
	  },
	  es: {
		translation: translationES,
	  },
	  pt: {
		translation: translationPT,
	  },
	  'pt-br': {
		translation: translationPTBR,
	  },
	  fr: {
		translation: translationFR,
	  },
    it: {
		translation: translationIT,
	  },
	he: {
		translation: translationHE,
	  },
    },  
    fallbackLng: 'en',
    debug: true,
    detection: {
      order: ['queryString', 'cookie'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
